// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1LHXB","overflowing":"ReadFullNote_overflowing__2GWWT"};